// extracted by mini-css-extract-plugin
module.exports = {"container":"exo-works_container__DmkZf","wellstar":"exo-works_wellstar__TInfN","videoSectionContainer":"exo-works_videoSectionContainer__uLO80"};